import { DailyOverviewTabs } from './DailyOverviewTabs';
import { DailyTimePicker } from './DailyTimePicker';

export const DailyHeader = ({ tab, setTab }: { tab: string; setTab: (tab: string) => void }) => {
  return (
    <>
      <DailyOverviewTabs tab={tab} setTab={setTab} />
      <DailyTimePicker />
    </>
  );
};
